import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import BadgeIcon from "../../../Assets/award.png";

const Portfolio_Badge = (props) => {
  return (
    <div>
      <Flex
        px={2}
        py={2}
        border="1px solid #D9D9D9"
        borderRadius={40}
        bg={props.bg}
        color={props.color}
        justify={"center"}
        align={"center"}
      >
        <img
          style={{ height: "18px", width: "18px" }}
          src={BadgeIcon}
          alt="badge"
        />
        <Text fontSize={14} fontFamily={"Roboto"} fontWeight={500}>
          {props.name}
        </Text>
      </Flex>
    </div>
  );
};

export default Portfolio_Badge;
